import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { HelperServiceService } from '../../../utils/helper-service.service';
import { Store } from '@ngrx/store';
import { selectCourseType } from '../../../pages/courses/create-courses/store/course.selector';
import { CourseService } from '../../../pages/courses/course.service';
import { CouponService } from '../../../pages/courses/coupon.service';
import { ToasterService } from '../../../providers/toaster/toaster.service';
import { ActivatedRoute } from '@angular/router';
import { youtubeUrlPattern } from '../../../providers/regexPattern';
import { NonNegativeDirective } from "../../../utils/non-negative.directive";
import { CoursePreviewRefreshService } from '../../../providers/course-preview-refresh.service';
import {
  benefitsValidator,
  fixedDateNotPastValidator,
  featuresValidator,
  howToUseValidator,
  nonNegativeDigitsValidator,
  maxDigitsLengthValidator,

  daysValidityValidator,
  othersOptionalValidator,
  termsAndConditionValidator,
  usefulForValidator,
} from '../../../utils/create_course_validators/details/detailsValidators';
import {
  couponCodeValidator,
  couponDiscountAmountValidator,
  couponFromNotPastDateValidator,
  couponNotPastDateValidator,
  couponToOnOrAfterFromDateValidator,
  couponTitleValidator,
  couponUsagePerUserValidator,
} from '../../../utils/create_course_validators/details/couponValidators';



type ToggleableFields = 'benefits' | 'usefull_for' | 'features' | 'how_to_use' | 'others' | 'terms_condition';
@Component({
  selector: 'app-details',
  standalone: true,
  imports: [FormsModule, CommonModule, ReactiveFormsModule, NonNegativeDirective],
  templateUrl: './details.component.html',
  styleUrl: './details.component.css'
})
export class DetailsComponent {
  @ViewChild('couponCard', { static: false }) couponCard!: ElementRef;
  @ViewChild('discountCouponModal', { static: false }) discountCouponModal!: ElementRef<HTMLDialogElement>;
  @ViewChild('viewCouponModal', { static: false }) viewCouponModal!: ElementRef<HTMLDialogElement>;
  savingCoupon = false;
  hasBenefits = false;
  hasUsefullFor = false;
  hasFeatures = false;
  hasHowToUse = false;
  hasOthers = false;
  hasTermsCondition = false;
  isreqSending: boolean = false;

  openCouponModal(): void {
    this.discountCouponModal?.nativeElement?.showModal();
  }

  closeCouponModal(): void {
    this.discountCouponModal?.nativeElement?.close();
  }


  finalPrice: number = 0;
  isPrizeCustimizable: boolean = false
  validatyIsFixedDate: boolean = true
  detailForm!: FormGroup
  couponForm!: FormGroup


  activeMaskShape: string = 'mask-squircle';
  bgFromColor: string = 'red-600';
  bgToColor: string = 'red-950';

  couponImage: any = '';
  couponImageUrl: any = '';

  customCouponImage: any = '';
  customCouponImageUrl: any = '';
  viewCoupon: any = null;
  courseId: any = '';
  courseType: any = {};
  chapterList: any = []
  couponsList: any = []
  selectedCouponIds: (string | number)[] = [];
  pendingCouponIdsFromApi: (string | number)[] | null = null;
  appliedCoupon: any = null;
  appliedCoupons: any[] = [];
  validityDaysInput: number | null = null;
  todayDate: string = this.formatDateForInput(new Date());
  viewCouponImageUrl: any = 'https://images.template.net/460326/Modern-Coupon-Template-edit-online.png';
  shades = [
    {
      "color": "slate",
      "shades": ["slate-500", "slate-600", "slate-700", "slate-800", "slate-900", "slate-950"]
    },
    {
      "color": "gray",
      "shades": ["gray-500", "gray-600", "gray-700", "gray-800", "gray-900", "gray-950"]
    },
    {
      "color": "zinc",
      "shades": ["zinc-500", "zinc-600", "zinc-700", "zinc-800", "zinc-900", "zinc-950"]
    },
    {
      "color": "neutral",
      "shades": ["neutral-500", "neutral-600", "neutral-700", "neutral-800", "neutral-900", "neutral-950"]
    },
    {
      "color": "stone",
      "shades": ["stone-500", "stone-600", "stone-700", "stone-800", "stone-900", "stone-950"]
    },
    {
      "color": "red",
      "shades": ["red-500", "red-600", "red-700", "red-800", "red-900", "red-950"]
    },
    {
      "color": "orange",
      "shades": ["orange-500", "orange-600", "orange-700", "orange-800", "orange-900", "orange-950"]
    },
    {
      "color": "amber",
      "shades": ["amber-500", "amber-600", "amber-700", "amber-800", "amber-900", "amber-950"]
    },
    {
      "color": "yellow",
      "shades": ["yellow-500", "yellow-600", "yellow-700", "yellow-800", "yellow-900", "yellow-950"]
    },
    {
      "color": "lime",
      "shades": ["lime-500", "lime-600", "lime-700", "lime-800", "lime-900", "lime-950"]
    },
    {
      "color": "green",
      "shades": ["green-500", "green-600", "green-700", "green-800", "green-900", "green-950"]
    },
    {
      "color": "emerald",
      "shades": ["emerald-500", "emerald-600", "emerald-700", "emerald-800", "emerald-900", "emerald-950"]
    },
    {
      "color": "teal",
      "shades": ["teal-500", "teal-600", "teal-700", "teal-800", "teal-900", "teal-950"]
    },
    {
      "color": "cyan",
      "shades": ["cyan-500", "cyan-600", "cyan-700", "cyan-800", "cyan-900", "cyan-950"]
    },
    {
      "color": "sky",
      "shades": ["sky-500", "sky-600", "sky-700", "sky-800", "sky-900", "sky-950"]
    },
    {
      "color": "blue",
      "shades": ["blue-500", "blue-600", "blue-700", "blue-800", "blue-900", "blue-950"]
    },
    {
      "color": "indigo",
      "shades": ["indigo-500", "indigo-600", "indigo-700", "indigo-800", "indigo-900", "indigo-950"]
    },
    {
      "color": "violet",
      "shades": ["violet-500", "violet-600", "violet-700", "violet-800", "violet-900", "violet-950"]
    },
    {
      "color": "purple",
      "shades": ["purple-500", "purple-600", "purple-700", "purple-800", "purple-900", "purple-950"]
    },
    {
      "color": "fuchsia",
      "shades": ["fuchsia-500", "fuchsia-600", "fuchsia-700", "fuchsia-800", "fuchsia-900", "fuchsia-950"]
    },
    {
      "color": "pink",
      "shades": ["pink-500", "pink-600", "pink-700", "pink-800", "pink-900", "pink-950"]
    },
    {
      "color": "rose",
      "shades": ["rose-500", "rose-600", "rose-700", "rose-800", "rose-900", "rose-950"]
    }
  ]

  maskShapes = [
    { "class": "mask-squircle", "shape": "Squircle" },
    { "class": "mask-heart", "shape": "Heart" },
    { "class": "mask-hexagon", "shape": "Hexagon" },
    { "class": "mask-hexagon-2", "shape": "Hexagon-2" },
    { "class": "mask-decagon", "shape": "Decagon" },
    { "class": "mask-pentagon", "shape": "Pentagon" },
    { "class": "mask-diamond", "shape": "Diamond" },
    { "class": "mask-square", "shape": "Square" },
    { "class": "mask-circle", "shape": "Circle" },
    { "class": "mask-parallelogram", "shape": "Parallelogram" },
    { "class": "mask-parallelogram-2", "shape": "Parallelogram-2" },
    { "class": "mask-parallelogram-3", "shape": "Parallelogram-3" },
    { "class": "mask-parallelogram-4", "shape": "Parallelogram-4" },
    { "class": "mask-star", "shape": "Star" },
    { "class": "mask-star-2", "shape": "Star-2" },
    { "class": "mask-triangle", "shape": "Triangle" },
    { "class": "mask-triangle-2", "shape": "Triangle-2" },
    { "class": "mask-triangle-3", "shape": "Triangle-3" },
    { "class": "mask-triangle-4", "shape": "Triangle-4" }
  ]





  constructor(private helperService: HelperServiceService, private fb: FormBuilder,
    private store: Store,
    private couseApiService: CourseService,
    private couponService: CouponService,
    private toasterService: ToasterService,
    private route: ActivatedRoute,
    private previewRefresh: CoursePreviewRefreshService
  ) {
  }

  ngOnInit(): void {
    this.store.select(selectCourseType).subscribe(value => {
      this.courseType = value
      this.courseId = value?.id ?? '';
      if (!this.courseId) {
        this.route.paramMap.subscribe(params => {
          this.courseId = params.get('id') || '';
        });
      }
    })



    const todayIso = this.todayDate;

    this.detailForm = this.fb.group({
      course_id: [this.courseId, Validators.required],
      benefits: [''],
      usefull_for: [''],
      features: [''],
      validity: ['', [Validators.required, fixedDateNotPastValidator(todayIso)]],
      how_to_use: [''],
      youtube_link: this.fb.array([]),
      others: [''],
      terms_condition: [''],
      coupon_ids: this.fb.array([]),
      price_detail: this.fb.group({
        custmization_price: [0],
        price: ['', [Validators.required, nonNegativeDigitsValidator({ min: 0, errorKey: 'priceInvalid' }), maxDigitsLengthValidator(7, 'priceMaxLength')]],
        gross_total: ['', [nonNegativeDigitsValidator({ min: 0, errorKey: 'grossTotalInvalid' }), maxDigitsLengthValidator(7, 'grossTotalMaxLength')]],
        discount_type: ['%'],
        gross_discount: ['', [nonNegativeDigitsValidator({ min: 0, errorKey: 'grossDiscountInvalid' }), maxDigitsLengthValidator(7, 'grossDiscountMaxLength')]],

        price_per_flashcard: ['', [nonNegativeDigitsValidator({ min: 0, errorKey: 'pricePerFlashcardInvalid' }), maxDigitsLengthValidator(7, 'pricePerFlashcardMaxLength')]],
        custmization_price_detail: this.fb.array([])
      })
    });
    this.couponForm = this.fb.group({
      title: ['', [Validators.required, couponTitleValidator()]],
      code: ['', [Validators.required, couponCodeValidator({ preferUppercase: true })]],
      discount_type: ['$', Validators.required],
      discount_amount: [
        '',
        [Validators.required, Validators.pattern(/^\d+$/)],
      ],
      from_date: ['', Validators.required],
      to_date: ['', Validators.required],
      usage_per_user: ['1', [Validators.required, Validators.pattern(/^\d+$/)]],
      image_shape: [this.activeMaskShape],
      coupon_image: [null],
      uploaded_coupon_image: [null],

      background_start_color: ['#ff5e62'],
      background_end_color: ['#ff5e62'],
    });


    // Coupon validators depend on selected course price.
    const priceGetter = () => {
      const raw = this.detailForm?.get('price_detail.price')?.value;
      return Number(raw ?? 0);
    };
    const discountTypeGetter = () => this.couponForm.get('discount_type')?.value as any;

    this.couponForm.get('discount_amount')?.setValidators([
      Validators.required,
      Validators.pattern(/^\d+$/),
      maxDigitsLengthValidator(7, 'couponDiscountMaxLength'),
      couponDiscountAmountValidator({
        getCoursePrice: priceGetter,
        getDiscountType: discountTypeGetter,
      }),
    ]);

    // Dates must not be in the past.
    this.couponForm.get('from_date')?.setValidators([
      Validators.required,
      couponFromNotPastDateValidator(this.todayDate),
    ]);

    // Expiry must not be past.
    this.couponForm.get('to_date')?.setValidators([
      Validators.required,
      couponNotPastDateValidator(this.todayDate),
    ]);


    // Usage per user max.
    this.couponForm.get('usage_per_user')?.setValidators([
      Validators.required,
      Validators.pattern(/^\d+$/),
      couponUsagePerUserValidator({ max: 999 }),
    ]);

    this.couponForm.get('discount_amount')?.updateValueAndValidity({ emitEvent: false });
    this.couponForm.get('from_date')?.updateValueAndValidity({ emitEvent: false });
    this.couponForm.get('to_date')?.updateValueAndValidity({ emitEvent: false });
    this.couponForm.get('usage_per_user')?.updateValueAndValidity({ emitEvent: false });

    // Cross-field date range: to_date >= from_date
    this.couponForm.setValidators([
      couponToOnOrAfterFromDateValidator({
        fromControlName: 'from_date',
        toControlName: 'to_date',
      })
    ]);
    this.couponForm.updateValueAndValidity({ emitEvent: false });

    this.setupDiscountValidators();
    // Apply text validators (only active when checkbox is selected) in handleFieldToggle()
    this.initializeForm();
  }


  async initializeForm() {
    await this.getChapters(this.courseId);
    this.getCoupons();
    this.getData(this.courseId);
  }



  getData(id: any) {
    if (id) {
      this.couseApiService.getCourseDeatils(id).subscribe((res: any) => {
        try {
          if (res && res.body.status === 'success') {
            this.patchValue(res.body.data);
          } else {
            this.getChapters(id);
          }
        } catch (error) {
          console.log(error);
        }
      });
    }

  }
  getChapters(id: any) {
    this.couseApiService.getChaptersData(id).subscribe((res: any) => {
      try {
        if (res && res.body.status === 'success') {
          this.chapterList = res.body.data;
          if (this.chapterList) {

            const formArray = this.detailForm.get('price_detail.custmization_price_detail') as FormArray;
            formArray.clear();

            this.chapterList.forEach((chapter: any) => {
              formArray.push(
                this.fb.group({
                  action_id: [chapter.id, Validators.required],
                  action_type: ['chapter'],
                  structure_name: [chapter.structure_name, Validators.required],
                  price: ['']
                })
              );
            });

          }
        }
      } catch (error) {
        console.log(error);
      }
    })





  }

  getCoupons() {
    this.couponService.getAllCoupons().subscribe((res: any) => {
      try {
        if (res && res.body.status === 'success') {
          const list = Array.isArray(res.body.data) ? res.body.data : [];
          this.couponsList = list.map((coupon: any) => this.normalizeCouponFromApi(coupon));
          if (this.pendingCouponIdsFromApi?.length) {
            this.tryApplyCouponDiscount(this.pendingCouponIdsFromApi[this.pendingCouponIdsFromApi.length - 1], false);
            this.pendingCouponIdsFromApi = null;
          } else {
            this.tryApplyCouponDiscount(undefined, false);
          }
        }
      } catch (error) {
        console.log(error);
      }
    })
  }

  patchValue(data: any) {
    if (!data) return;

    this.detailForm.patchValue({
      course_id: data.course_id,
      benefits: data.benefits ?? '',
      usefull_for: data.usefull_for ?? '',
      features: data.features ?? '',
      validity: this.normalizeDateInput(data.validity),
      how_to_use: data.how_to_use ?? '',
      others: data.others ?? '',
      terms_condition: data.terms_condition ?? '',
      price_detail: {
        custmization_price: data.price?.custmization_price,
        price: data.price?.price,
        gross_total: data.price?.gross_total,
        discount_type: data.price?.discount_type,
        gross_discount: data.price?.gross_discount,
        price_per_flashcard: data.price?.price_per_flashcard ?? ''
      }
    });

    this.validityDaysInput = this.calculateDaysFromToday(this.detailForm.get('validity')?.value);
    this.validatyIsFixedDate = true;

    const youtubeArray = this.youtubeLinks;
    youtubeArray.clear();
    data.youtube_link?.forEach((link: string) => {
      youtubeArray.push(this.fb.control(link));
    });

    const custPriceDetail = this.custmizationPriceDetails;
    if (Array.isArray(data.price?.customizations)) {
      data.price.customizations.forEach((item: any) => {
        const matchingGroup = custPriceDetail.controls.find((group: any) =>
          String(group.get('action_id')?.value) === String(item.action_id)
        );

        if (matchingGroup) {
          matchingGroup.patchValue({ price: item.price });
        }
      });
    }


    const couponIdsFromApi = data.coupon_ids || [];
    const normalizedCouponIds = Array.isArray(couponIdsFromApi)
  ? couponIdsFromApi
  : typeof couponIdsFromApi === 'string'
    ? couponIdsFromApi.split(',').map((id) => id.trim()).filter(Boolean)
    : typeof couponIdsFromApi === 'number'
      ? [couponIdsFromApi]
      : [];

this.selectedCouponIds = normalizedCouponIds.filter(
  id => String(id) !== '0'
);

    this.finalPrice = Number(data.price?.final_price || 0);

    const formValue = this.detailForm.value;

    this.hasBenefits = !!formValue.benefits?.trim();
    this.hasUsefullFor = !!formValue.usefull_for?.trim();
    this.hasFeatures = !!formValue.features?.trim();
    this.hasHowToUse = !!formValue.how_to_use?.trim();
    this.hasOthers = !!formValue.others?.trim();
    this.hasTermsCondition = !!formValue.terms_condition?.trim();

    this.isPrizeCustimizable = formValue.price_detail.custmization_price == 1 ? true : false;

    if (!this.isPrizeCustimizable) {
      this.detailForm.get('price_detail')?.get('price_per_flashcard')?.setValue('');
    }


    this.calculateGrossTotal();
    this.calculateFinalPrice();


  }


  get youtubeLinks(): FormArray {
    return this.detailForm.get('youtube_link') as FormArray;
  }

  get custmizationPriceDetails(): FormArray {
    return this.detailForm.get('price_detail.custmization_price_detail') as FormArray;
  }

  onCustomizationPriceChange() {
    this.calculateGrossTotal();
  }

  onSubmit() {

    const validity = this.detailForm.get('validity')?.value;
    if (!this.isDateOnOrAfterToday(validity)) {
      this.detailForm.get('validity')?.setErrors({ pastDate: true });
      this.detailForm.get('validity')?.markAsTouched();
      this.toasterService.setToaster('error', 'Invalid Validity', 'Please select today or a future date.');
      return;
    }

    this.calculateFinalPrice();
    if (this.hasNetAmountMaxLengthError()) {
      this.detailForm.get('price_detail.gross_discount')?.markAsTouched();
      this.toasterService.setToaster('error', 'Invalid Form', 'Net amount cannot exceed 7 digits.');
      return;
    }

    if (this.detailForm.invalid) {
      this.detailForm.markAllAsTouched();
      this.toasterService.setToaster('error', 'Invalid Form', 'Please fill all required fields correctly.');
      return;
    }

    const rawPrice = Number(this.detailForm.get('price_detail.price')?.value || 0);
    const rawGrossTotal = Number(this.detailForm.get('price_detail.gross_total')?.value || 0);
    const grossTotal = rawGrossTotal > 0 ? rawGrossTotal : rawPrice;
    const grossDiscount = Number(this.detailForm.get('price_detail.gross_discount')?.value || 0);
    const netPrice = Number(this.finalPrice || 0);

    let data = {
      ...this.detailForm.value,
      benefits: this.hasBenefits ? this.detailForm.value.benefits : '',
      usefull_for: this.hasUsefullFor ? this.detailForm.value.usefull_for : '',
      features: this.hasFeatures ? this.detailForm.value.features : '',
      how_to_use: this.hasHowToUse ? this.detailForm.value.how_to_use : '',
      others: this.hasOthers ? this.detailForm.value.others : '',
      terms_condition: this.hasTermsCondition ? this.detailForm.value.terms_condition : '',
      coupon_ids: this.selectedCouponIds,
      "price_detail": {

        ...this.detailForm.value.price_detail,
        price: rawPrice,
        gross_total: grossTotal,
        gross_discount: grossDiscount,
        final_price: netPrice,
        "custmization_price_detail": this.isPrizeCustimizable ? this.detailForm.value.price_detail.custmization_price_detail : [],
      },
    };

    this.isreqSending = true;
    this.couseApiService.addCourseDeatils(data).subscribe((res: any) => {
      try {
        if (res && res.body.status === 'success') {
          this.toasterService.setToaster('success', 'Course Added', res.body.message ?? 'Course added successfully');
          this.previewRefresh.trigger(this.courseId, 'details');
          this.getData(this.courseId);
        }
      } catch (error) {

      }
      this.isreqSending = false;
    })



  }


  async saveCoupon(event?: Event): Promise<void> {
    event?.preventDefault();
    event?.stopPropagation();

    if (this.savingCoupon) {
      return;
    }

    const validationError = this.getCouponValidationError();
    if (validationError) {
      this.couponForm.markAllAsTouched();
      this.toasterService.setToaster('error', 'Error', validationError);
      return;
    }

    const couponImageFile = this.resolveCouponImageFile();
    const uploadedCouponImageFile = this.resolveUploadedCouponImageFile();

    if (couponImageFile && !this.isValidImageFile(couponImageFile)) {
      this.toasterService.setToaster('error', 'Invalid Image', 'Please select a valid card image file.');
      return;
    }

    if (uploadedCouponImageFile && !this.isValidImageFile(uploadedCouponImageFile)) {
      this.toasterService.setToaster('error', 'Invalid Image', 'Please select a valid uploaded coupon image file.');
      return;
    }

    const requestData = couponImageFile || uploadedCouponImageFile
      ? this.buildCouponFormData(couponImageFile, uploadedCouponImageFile)
      : this.buildCouponPayload();

    // Ensure code is uppercased before sending (validator may normalize, but keep safe).
    const codeCtrl = this.couponForm.get('code');
    if (codeCtrl?.value) {
      codeCtrl.setValue(String(codeCtrl.value).toUpperCase(), { emitEvent: false });
    }

    this.savingCoupon = true;
    this.couponService.createCoupon(requestData).subscribe({
      next: (res: any) => {
        this.savingCoupon = false;
        const isSuccess =
          res?.body?.status === 'success' ||
          res?.body?.success === true ||
          res?.status === 200 ||
          res?.status === 201;

        if (isSuccess) {
          this.toasterService.setToaster(
            'success',
            'Coupon Added',
            res?.body?.message ?? res?.body?.data?.message ?? 'Coupon added successfully'
          );
          const savedCoupon = res?.body?.data ?? res?.body;
          this.getCoupons();
          this.getData(this.courseId);
          this.resetCouponForm();
          this.closeCouponModal();
          if (savedCoupon?.uploaded_coupon_image) {
            this.viewCouponImage(savedCoupon);
          }
          return;
        }
        this.toasterService.setToaster('error', 'Error', res?.body?.message ?? 'Failed to save coupon');
      },
      error: (error: any) => {
        this.savingCoupon = false;
        const apiErrors = error?.error?.errors;
        if (apiErrors && typeof apiErrors === 'object') {
          const firstError = Object.values(apiErrors).flat()[0];
          this.toasterService.setToaster(
            'error',
            'Validation Failed',
            String(firstError ?? error?.error?.message ?? 'Failed to save coupon')
          );
          return;
        }
        this.toasterService.setToaster('error', 'Error', error?.error?.message ?? 'Failed to save coupon');
      }
    });
  }

  private resetCouponForm(): void {

    this.couponForm.reset({
      title: '',
      code: '',
      discount_type: '$',
      discount_amount: '',
      from_date: '',
      to_date: '',
      usage_per_user: '1',
      image_shape: this.activeMaskShape,
      coupon_image: null,
      background_start_color: '#ff5e62',
      background_end_color: '#ff5e62'
    });
    this.couponImage = '';
    this.couponImageUrl = '';
    this.customCouponImage = null;
    this.customCouponImageUrl = null;
    this.couponForm.get('uploaded_coupon_image')?.setValue(null);
    this.activeMaskShape = 'mask-squircle';
    this.bgFromColor = 'red-600';
    this.bgToColor = 'red-950';
  }

  private getCouponValidationError(): string | null {
    // Keep existing image requirement (API likely expects one of them).
    const couponImageFile = this.resolveCouponImageFile();
    const uploadedCouponImageFile = this.resolveUploadedCouponImageFile();
    if (!couponImageFile && !uploadedCouponImageFile) {
      return 'Either coupon card image or uploaded coupon image is required';
    }

    // Date relation validation.
    const fromDate = this.couponForm.get('from_date')?.value;
    const toDate = this.couponForm.get('to_date')?.value;
    if (fromDate && toDate && String(fromDate) > String(toDate)) {
      return 'To date must be on or after from date';
    }

    // Let reactive validators drive field-level errors.
    if (this.couponForm.invalid) return 'Please correct coupon fields';

    return null;
  }

  private buildCouponPayload(): Record<string, string | number> {
    const bgStart = String(this.couponForm.get('background_start_color')?.value ?? this.bgFromColor);
    const bgEnd = String(this.couponForm.get('background_end_color')?.value ?? this.bgToColor);

    return {
      title: String(this.couponForm.get('title')?.value ?? '').trim(),
      code: String(this.couponForm.get('code')?.value ?? '').trim(),
      discount_type: String(this.couponForm.get('discount_type')?.value ?? '%'),

      discount_amount: String(this.couponForm.get('discount_amount')?.value ?? ''),
      from_date: String(this.couponForm.get('from_date')?.value ?? ''),
      to_date: String(this.couponForm.get('to_date')?.value ?? ''),
      usage_per_user: String(this.couponForm.get('usage_per_user')?.value ?? '0'),
      image_shape: String(this.couponForm.get('image_shape')?.value ?? this.activeMaskShape),

      // Additional background settings (dynamic)
      background_color: String(this.couponForm.get('background_color')?.value ?? ''),
      background_start_color: bgStart,
      background_end_color: bgEnd,
      is_active: 1
    };
  }

  private buildCouponFormData(couponImageFile: File | null, uploadedCouponImageFile: File | null): FormData {
    const formData = new FormData();
    const payload = this.buildCouponPayload();

    Object.entries(payload).forEach(([key, value]) => {
      // keep consistent backend key expectations
      formData.append(key, String(value));
    });

    if (couponImageFile) {
      formData.append('coupon_image', couponImageFile, couponImageFile.name || 'coupon-image.png');
    }

    if (uploadedCouponImageFile) {
      formData.append('uploaded_coupon_image', uploadedCouponImageFile, uploadedCouponImageFile.name || 'uploaded-coupon-image.png');
    }

    return formData;
  }

  private isValidImageFile(file: unknown): file is File {
    return file instanceof File && file.type.startsWith('image/');
  }

  private normalizeCouponFromApi(coupon: any): any {
    const discountType = String(coupon?.discount_type ?? '%');
    const uiDiscountType = discountType === '$' || discountType === '%' ? discountType : '%';

    return {
      ...coupon,
      code: coupon?.code ?? coupon?.coupon_code ?? '',
      title: coupon?.title ?? coupon?.description ?? '',
      discount_amount: coupon?.discount_amount ?? coupon?.discount_value ?? 0,
      discount_type: uiDiscountType,
      from_date: coupon?.from_date ?? coupon?.start_date ?? '',
      to_date: coupon?.to_date ?? coupon?.end_date ?? '',
      usage_per_user: coupon?.usage_per_user ?? coupon?.min_order_amount ?? 0
    };
  }

  private resolveCouponImageFile(): File | null {
    // The left-side coupon card image should be sent as coupon_image.
    const formImage = this.couponForm.get('coupon_image')?.value;
    if (this.isValidImageFile(formImage)) {
      return formImage;
    }

    if (this.isValidImageFile(this.couponImage)) {
      return this.couponImage;
    }

    return null;
  }

  private resolveUploadedCouponImageFile(): File | null {
    // The OR upload image should be sent as uploaded_coupon_image.
    const uploadedFormImage = this.couponForm.get('uploaded_coupon_image')?.value;
    if (this.isValidImageFile(uploadedFormImage)) {
      return uploadedFormImage;
    }

    if (this.isValidImageFile(this.customCouponImage)) {
      return this.customCouponImage;
    }

    return null;
  }


  addRemoveYoutubeLink(action: 'add' | 'remove', index?: number) {
    if (action == 'add') {
      this.youtubeLinks.push(this.fb.control('', [Validators.required ,Validators.pattern(youtubeUrlPattern)]));
    } else {
      if (index !== undefined) {
        this.youtubeLinks.removeAt(index);
      }
    }
  }




  setValidaty(e: Event, type: string) {
    const target = e.target as HTMLInputElement;
    const value = target.value;

    // validity control always stores final date (yyyy-mm-dd)
    const validityControl = this.detailForm.get('validity');

    if (!validityControl) return;

    if (type === 'days') {
      // validate days input via digits/max rules, then compute date
      const daysErrors = (() => {
        const v = String(value ?? '');
        if (!/^\d+$/.test(v)) return { digitsOnly: true };
        const n = Number(v);
        if (!Number.isFinite(n) || n < 1) return { minValue: true };
        if (n > 3650) return { maxValue: true };
        return null;
      })() as any;
      const parsedDays = Number(value);

      if (daysErrors || !Number.isFinite(parsedDays) || parsedDays < 1) {
        this.validityDaysInput = null;
        validityControl.setValue('');
        validityControl.setErrors({ daysInvalid: true });
        return;
      }

      const date = new Date();
      date.setDate(date.getDate() + parsedDays);
      this.validityDaysInput = parsedDays;
      validityControl.setValue(this.formatDateForInput(date), { emitEvent: true });
    } else {
      this.validityDaysInput = this.calculateDaysFromToday(value);
      validityControl.setValue(value, { emitEvent: true });

      if (!this.isDateOnOrAfterToday(value)) {
        validityControl.setErrors({ pastDate: true });
      }
    }

    validityControl.updateValueAndValidity();
    validityControl.markAsTouched();
  }

  setIsPrizeCustimizable(e: Event) {
    const target = e.target as HTMLInputElement;
    this.isPrizeCustimizable = target.checked;
    const priceDetail = this.detailForm.get('price_detail');
    if (this.isPrizeCustimizable) {
      priceDetail?.get('custmization_price')?.setValue(1);
    } else {
      priceDetail?.get('custmization_price')?.setValue(0);
      priceDetail?.get('price_per_flashcard')?.setValue('');
    }
    this.calculateGrossTotal();
  }


  handleFieldToggle(field: ToggleableFields, event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    const control = this.detailForm.get(field);
    (this as any)[`has${this.toPascalCase(field)}`] = isChecked;

    if (!control) return;

    if (isChecked) {
      const validators: any[] = [Validators.required];
      if (field === 'benefits') validators.push(benefitsValidator());
      if (field === 'usefull_for') validators.push(usefulForValidator());
      if (field === 'features') validators.push(featuresValidator());
      if (field === 'how_to_use') validators.push(howToUseValidator());
      if (field === 'others') validators.push(othersOptionalValidator());
      if (field === 'terms_condition') validators.push(termsAndConditionValidator());

      control.setValidators(validators);
    } else {
      control.clearValidators();
    }

    // When unchecked, keep model value empty so backend doesn't receive invalid junk.
    if (!isChecked) {
      control.setValue('', { emitEvent: false });
    }

    control.updateValueAndValidity();
  }

  private toPascalCase(str: string): string {
    return str.split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join('');
  }



  calculateFinalPrice() {
    const total = Number(this.detailForm.get('price_detail.price')?.value || 0);
    const grossTotal = Number(this.detailForm.get('price_detail.gross_total')?.value || 0);
    const discountType = this.detailForm.get('price_detail.discount_type')?.value;
    const grossDiscount = Number(this.detailForm.get('price_detail.gross_discount')?.value || 0);
    const base = grossTotal > 0 ? grossTotal : total;
    let final_price = 0;
    if (discountType === '%') {
      final_price = +(base - (base * grossDiscount / 100)).toFixed(2);
    } else if (discountType === '$') {
      final_price = +(base - grossDiscount).toFixed(2);
    } else {
      final_price = base;
    }
    this.finalPrice = Math.max(0, +final_price.toFixed(2));
  }

  hasNetAmountMaxLengthError(): boolean {
    const integerPart = String(Math.trunc(Math.abs(Number(this.finalPrice || 0))));
    return integerPart.length > 7;
  }

  calculateGrossTotal() {
    const basePrice = Number(this.detailForm.get('price_detail.price')?.value || 0);
    let customizationTotal = 0;

    if (this.courseType?.type === 'video' && this.isPrizeCustimizable) {
      customizationTotal = this.custmizationPriceDetails.controls.reduce((sum, group) => {
        const chapterPrice = Number(group.get('price')?.value || 0);
        return sum + (Number.isFinite(chapterPrice) ? chapterPrice : 0);
      }, 0);
    }

    const grossTotal = basePrice;
    this.detailForm.get('price_detail.gross_total')?.setValue(grossTotal, { emitEvent: false });
    this.calculateFinalPrice();
  }

  isCouponSelected(id: any): boolean {
    return this.selectedCouponIds.some((couponId) => String(couponId) === String(id));
  }

  toggleCouponSelection(id: any, checked: boolean) {

  if (checked) {
    if (!this.selectedCouponIds.some(couponId => String(couponId) === String(id))) {
      this.selectedCouponIds = [...this.selectedCouponIds, id];
    }
  } else {
    this.selectedCouponIds =
      this.selectedCouponIds.filter(couponId => String(couponId) !== String(id));
  }
  this.syncCouponIdsToForm();
}

  onCouponSelectionChange(id: any, event: Event): void {
    const checked = event.target instanceof HTMLInputElement ? event.target.checked : false;
    this.toggleCouponSelection(id, checked);
  }



  // ***************************** Image Upload Functionality ***************************** //
  viewCouponImage(coupon: any) {
    if (!coupon) return;
    this.viewCoupon = coupon;
    this.viewCouponModal?.nativeElement?.showModal();
  }

  closeViewCouponModal(): void {
    this.viewCoupon = null;
    this.viewCouponImageUrl = 'https://images.template.net/460326/Modern-Coupon-Template-edit-online.png';
    this.viewCouponModal?.nativeElement?.close();
  }

  public getViewCouponGradientStyle(): { [key: string]: string } {
    const start = this.viewCoupon?.background_start_color;
    const end = this.viewCoupon?.background_end_color;

    if (!start || !end) {
      return { background: `linear-gradient(to right, #ff5e62, #ff5e62)` };
    }

    if (this.isCssColor(start) && this.isCssColor(end)) {
      return {
        background: `linear-gradient(to right, ${start}, ${end})`
      };
    }

    return {};
  }

  public getViewCouponGradientClass(): string {
    const start = this.viewCoupon?.background_start_color;
    const end = this.viewCoupon?.background_end_color;

    if (!start || !end) {
      return '';
    }

    if (!this.isCssColor(start) || !this.isCssColor(end)) {
      return `bg-gradient-to-r from-${start} to-${end}`;
    }

    return '';
  }

  private isCssColor(value: string): boolean {
    return /^#([0-9A-Fa-f]{3}){1,2}$/.test(value) || /^rgb\(/.test(value) || /^rgba\(/.test(value);
  }

  public shouldShowDirectCouponImage(): boolean {
    return !!this.viewCoupon && !this.viewCoupon?.background_start_color && !this.viewCoupon?.background_end_color && !!this.viewCoupon?.coupon_image;
  }

  deleteCoupon(id: any) {
    if (!id) return;
    this.couponService.deleteCoupon(id).subscribe({
      next: (res: any) => {
        if (res?.body?.status === 'success') {
          this.toasterService.setToaster('success', 'Coupon Deleted', res.body.message ?? 'Coupon deleted successfully');
          this.couponsList = this.couponsList.filter((coupon: any) => String(coupon.id) !== String(id));
          this.selectedCouponIds = this.selectedCouponIds.filter((couponId) => String(couponId) !== String(id));
          this.syncCouponIdsToForm();
        } else {
          this.toasterService.setToaster('error', 'Delete Failed', res?.body?.message ?? 'Failed to delete coupon');
        }
      },
      error: (error) => {
        this.toasterService.setToaster('error', 'Delete Failed', error?.error?.message ?? 'Failed to delete coupon');
      }
    });
  }


  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = 'assets/dummy_thumbnail.png';
  }


  async onFileSelected(e: Event) {
    const input = e.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const image = input.files[0];

    // IMPORTANT: set the actual File into the form so saveCoupon() uploads it.
    this.couponForm.get('coupon_image')?.setValue(image);
    this.couponImage = image;

    const reader = new FileReader();
    reader.onload = () => {
      const imageUrl = reader.result as string;
      this.couponImageUrl = imageUrl;
    };

    reader.readAsDataURL(image);
  }




  onMaskShapeChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    this.activeMaskShape = target.value || '';
  }

  setBackgroundStartColor(shade: string): void {
    this.bgFromColor = shade;
    this.couponForm.get('background_start_color')?.setValue(shade);
  }

  setBackgroundEndColor(shade: string): void {
    this.bgToColor = shade;
    this.couponForm.get('background_end_color')?.setValue(shade);
  }

  addCouponImage(e: Event) {

    this.helperService.getImageWithAspectCheck(e, 'none').then(({ image, imageUrl }) => {
      if (image) {
        this.customCouponImage = image;
        this.customCouponImageUrl = imageUrl;
        this.couponForm.get('uploaded_coupon_image')?.setValue(image);
      }
    });
  }
  removeCouponImage() {
    this.customCouponImage = null;
    this.customCouponImageUrl = null;
    this.couponForm.get('uploaded_coupon_image')?.setValue(null);
  }

  private setupDiscountValidators() {
    const priceDetail = this.detailForm.get('price_detail') as FormGroup;
    const discountTypeControl = priceDetail.get('discount_type');
    const discountValueControl = priceDetail.get('gross_discount');

    const updateDiscountValidators = () => {
      if (!discountValueControl) return;
      const validators: ValidatorFn[] = [
        nonNegativeDigitsValidator({ min: 0, errorKey: 'grossDiscountInvalid' }),
        maxDigitsLengthValidator(7, 'grossDiscountMaxLength')
      ];
      if (discountTypeControl?.value === '%') {
        validators.push(Validators.max(100));
      }
      discountValueControl.setValidators(validators);
      discountValueControl.updateValueAndValidity({ emitEvent: false });
    };

    updateDiscountValidators();
    discountTypeControl?.valueChanges.subscribe(() => {
      updateDiscountValidators();
      this.calculateFinalPrice();
    });
  }

  private tryApplyCouponDiscount(preferId?: string | number, showToast: boolean = false) {
    if (!this.couponsList?.length) return;

    if (!this.selectedCouponIds?.length) {
      this.appliedCoupons = [];
      this.appliedCoupon = null;
      this.calculateFinalPrice();
      return;
    }

    this.appliedCoupons = this.selectedCouponIds
      .map((id) => this.couponsList.find((item: any) => String(item.id) === String(id)))
      .filter((coupon): coupon is any => !!coupon);

    this.appliedCoupon = this.appliedCoupons.length === 1 ? this.appliedCoupons[0] : null;
    this.calculateFinalPrice();

    if (showToast && this.appliedCoupon) {
      const discountType = this.appliedCoupon.discount_type === '%' ? '%' : '₹';
      this.toasterService.setToaster(
        'success',
        'Coupon Selected',
        'Coupon selected for this course'
      );
    }
  }

  private syncCouponIdsToForm() {
    const couponArray = this.detailForm.get('coupon_ids') as FormArray;
    couponArray.clear();
    this.selectedCouponIds.forEach((id) => couponArray.push(this.fb.control(id)));
  }

  private normalizeDateInput(rawValue: any): string {
    if (!rawValue) return '';
    const value = String(rawValue);
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return value;
    }
    const dateTimeMatch = value.match(/^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}:\d{2})/);
    if (!dateTimeMatch) {
      return value.split('T')[0];
    }

    const [, datePart, timePart] = dateTimeMatch;

    // Backend currently returns shifted datetime for date-only validity.
    // If non-midnight time is present, treat it as timezone-shifted date and normalize +1 day.
    if (timePart !== '00:00:00') {
      const correctedDate = new Date(`${datePart}T00:00:00`);
      correctedDate.setDate(correctedDate.getDate() + 1);
      return this.formatDateForInput(correctedDate);
    }

    return datePart;
  }

  private formatDateForInput(date: Date): string {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private isDateOnOrAfterToday(dateString: string): boolean {
    if (!dateString) return false;
    return dateString >= this.todayDate;
  }

  private calculateDaysFromToday(dateString: string | null | undefined): number | null {
    if (!dateString) return null;
    const selected = new Date(`${dateString}T00:00:00`);
    const today = new Date(`${this.todayDate}T00:00:00`);
    if (Number.isNaN(selected.getTime())) return null;
    const diffMs = selected.getTime() - today.getTime();
    return Math.max(0, Math.ceil(diffMs / (1000 * 60 * 60 * 24)));
  }
  async downloadCardAsImage(key: string = 'coupon-card'): Promise<void> {


  const binaryData = await this.helperService.generateElementPngBinary(this.couponCard);

  if (!binaryData) return;

  const uint8Array = new Uint8Array(binaryData);

  const blob = new Blob([uint8Array], {
    type: 'image/png'
  });

  const url = window.URL.createObjectURL(blob);

  const link = document.createElement('a');

  link.href = url;
  link.download = `${key}.png`;

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);

  window.URL.revokeObjectURL(url);
}


}
